module.exports = __webpack_public_path__ + "img/dollar-sign.e5f5188a.svg";